import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  notification,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageHeaders from "../../components/pageHeaders";
import { API } from "../../config/Api";
import { COMPRESS_IMAGE, GET, POST } from "../../utils/apiRequest";
import CountryCode from "../../utils/countryCodes.json";
import ImagePicker from "../components/imagePicker";
import "./styles.scss";
import dayjs from "dayjs";

function CreateBooking() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [subscription, setSubscription] = useState<any>([]);
  const [selectedSub, setSelectedSub] = useState<any>(null);
  const [selectedTok, setSelectedTok] = useState<any>(null);
  const [start_date, setStart_date] = useState<any>(null);
  const [end_date, setEnd_date] = useState<any>(null);
  const [price_amount, setPriceAmount] = useState<number>(0);
  const [duration, setDuration] = useState<any>(null);
  const [durationType, setDurationType] = useState<any>(null);
  const [accountType, setAccountType] = useState<string | null>(null);
  const User = useSelector((state: any) => state?.User?.user);
  const [userId, setUserId] = useState<any>();
  const [image1, setImage1] = useState<any>();
  const [image2, setImage2] = useState<any>();
  const [subscriptionData, setSubscriptionData] = useState<any>();
  const [selectedPlan, setSelectedPlan] = useState<string | null>(
    "subscription"
  );
  const [tokens, setTokens] = useState([]);

  useEffect(() => {
    getDetails();
    getTokens(1);
  }, []);

  const [form] = Form.useForm();
  const params = useParams();

  const getDetails = async () => {
    try {
      const details: any = await GET(
        `${API.SUBCRIPTION_OFFICE}${User?.office?.id}`,
        {}
      );
      if (details?.status) {
        setSubscription(details?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getTokens = async (pageNum: number) => {
    try {
      let api = `${API.LIST_TOKEN}?order=DESC&page=${pageNum}&take=500`;
      let payload = { office_id: User?.office?.id, is_token: true };
      const details: any = await POST(api, payload);
      if (details?.status) {
        setTokens(details.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAccountTypeChange = (value: string) => {
    setAccountType(value);
  };

  const handleSubscriptionChange = async (value: any, option: any) => {
    try {
      if (selectedPlan === "subscription") {
        setSelectedSub(option);
      } else {
        setSelectedTok(option);
      }
      const { duration_type, duration, price } = option;
      setPriceAmount(price);
      form.setFieldsValue({ paid_amount: price });
      form.setFieldsValue({ price_per_token: price });

      setDuration(duration);
      setDurationType(duration_type);

      // Calculate start and end dates based on the current date
      const currentDate = dayjs();
      const ranges: any = await FindDateRange(
        duration_type,
        duration,
        currentDate
      );

      setStart_date(ranges.start);
      setEnd_date(ranges.end);

      form.setFieldsValue({
        startDate: dayjs(ranges.start),
        endDate: dayjs(ranges.end),
      });
    } catch (err) {
      console.error("Error selecting subscription:", err);
    }
  };

  const ChangeSubDate = (start: any, end: any, type: any) => {
    try {
      if (!start || !end) {
        setStart_date(null);
        setEnd_date(null);
        return;
      }
      setStart_date(start);
      setEnd_date(end);
      const duro = duration || 0;
      if (type === 1) {
        let endDate = moment(start).add(duro, durationType);
        setEnd_date(endDate);
        form.setFieldsValue({ endDate: endDate });
      } else {
        let startDate = moment(end).subtract(duro, durationType);
        setStart_date(startDate);
        form.setFieldsValue({ startDate: startDate });
      }
    } catch (err) {
      console.log("Error in ChangeSubDate:", err);
    }
  };

  const onFinish = async (val: any) => {
    try {
      setIsLoading(true);
      const upload = image1 && (await COMPRESS_IMAGE(image1?.file));
      const upload2 = image2 && (await COMPRESS_IMAGE(image2?.file));

      // Process gateway devices
      const selectedDevices =
        val?.gate?.map((deviceId: string) =>
          User?.office?.devices?.find(
            (device: any) => device?.device_id === deviceId
          )
        ) || [];

      // Base payload for both create and update
      const basePayload = {
        first_name: val.first_name,
        last_name: val.last_name || "",
        c_code1: val.prefix1,
        number1: val.mobile_number,
        c_code2: val.prefix2,
        number2: val.mobile_number2,
        mobile_number: val.mobile_number
          ? val.prefix1 + val.mobile_number
          : null,
        mobile_number2: val.mobile_number2
          ? val.prefix2 + val.mobile_number2
          : null,
        birth_date: val.birth_date
          ? dayjs(val.birth_date).format("YYYY/MM/DD")
          : null,
        place: val.place,
        blood: val.blood,
        gender: val.gender,
        weight: Number(val.weight) || 0,
        height: Number(val.height) || 0,
        email: val.email || null,
        gates: selectedDevices,
        type: val.type,
        password: val.type === "trainer" ? val.password : null,
        photo: upload?.url,
        id_proof: upload2?.url,
        subscription_name:
          selectedSub?.name || selectedTok?.name || subscriptionData?.name,
        subscription_id:
          selectedSub?.id || selectedTok?.id || subscriptionData?.id,
        start_date: start_date || moment(userId?.start_date),
        end_date: end_date || moment(userId?.end_date),
      };

      // Additional fields for create operation
      const createFields = !params?.id
        ? {
            prefix: val.prefix ?? User?.office?.prefix,
            office_name: User?.office?.name,
            office_id: User?.office?.id,
            status: !!(selectedSub?.name || selectedTok?.name),
            suffix: val.suffix,
            register_date: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            paid_amount:
              Number(val.paided_amount) >= 0 ? Number(val.paided_amount) : 0,
            amount: price_amount,
            token_id: selectedTok?.id,
            payment_method: val.payment_method,
            plan_type:
              selectedSub?.id || selectedTok?.id ? val.plan_type : null,
            ...(val.plan_type === "token"
              ? { token_count: val.tokenCount ?? 1 }
              : {}),
            discount: val.discount,
            disc_type: val.discount_type,
          }
        : {};

      // ID field for update operation
      const idField = params?.id ? { id: Number(params.id) } : {};

      const payload = {
        ...basePayload,
        ...createFields,
        ...idField,
      };

      const url = params?.id ? API.USER_UPDATE : API.USER_ADD;
      const response: any = await POST(url, payload);
      console.log(response, "responseresponseresponseresponse");

      if (response?.status) {
        notification.success({
          message: "Success",
          description: `Successfully ${params?.id ? "updated" : "created"} user`,
        });

        // Handle WhatsApp message for new users
        if (!params?.id && response?.data?.transaction?.data) {
          const transactionDetails = response.data.transaction.data;
          const message = constructWhatsAppMessage(val, transactionDetails);
          const whatsappNumber = val.prefix1 + val.mobile_number;

          if (whatsappNumber) {
            const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, "_blank");
          }
        }

        navigate("/Auth/users/all");
      } else {
        console.log(response?.message, " response?.message");

        notification.error({
          message: "Error",
          description:
            response?.message || "An error occurred while processing the user.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      notification.error({
        message: "Error",
        description: "An unexpected error occurred.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to construct WhatsApp message
  const constructWhatsAppMessage = (formData: any, transactionDetails: any) => {
    let message = `Hello ${formData.first_name}\nWelcome to ${User?.office?.name}\n`;

    message += `Your subscription to ${transactionDetails?.subscription_name || selectedSub?.name || subscriptionData?.name} was successfully added and will expire on ${moment(transactionDetails?.end_date || end_date).format("DD MMM YYYY")}.\n`;
    message += `Amount ₹${transactionDetails?.total_amount || price_amount}\n`;
    message += `Paid ₹${transactionDetails?.paid_amount || formData.paided_amount}\n`;
    message += `Balance ₹${transactionDetails?.outstanding || (Number(price_amount) - Number(formData.paided_amount))}\n`;
    message += `\nPlease find your invoice here:\nhttps://xentrybook.com/invoice/${transactionDetails.transaction_id}\n`;
    message += `\nThank You\n\n${User?.office?.more_info || ""}`;

    return message;
  };

  const getUser = async () => {
    try {
      setIsLoading(true);
      let api = API.USER_DETAILS + params?.id;
      const response: any = await GET(api, null);
      if (response?.status) {
        setUserId(response?.data?.user);
        setSubscriptionData(response?.data?.subscription);
        const gateDeviceIds = response?.data?.user?.gates?.map(
          (gate: any) => gate.device_id
        );
        const birthDate = response?.data?.user?.birth_date
          ? dayjs(response?.data?.user?.birth_date).format("YYYY/MM/DD")
          : null;

        setAccountType(response?.data?.user?.type);
        setIsLoading(false);
        form.setFieldsValue({
          first_name: response?.data?.user?.first_name,
          last_name: response?.data?.user?.last_name,
          prefix1: response?.data?.user?.c_code1,
          prefix2: response?.data?.user?.c_code2,
          mobile_number: response?.data?.user?.number1,
          mobile_number2: response?.data?.user?.number2,
          suffix: response?.data?.user?.suffix,
          email: response?.data?.user?.email,
          gender: response?.data?.user?.gender,
          birth_date: birthDate ? dayjs(birthDate, "YYYY/MM/DD") : null,
          blood: response?.data?.user?.blood,
          weight: response?.data?.user?.weight,
          height: response?.data?.user?.height,
          place: response?.data?.user?.place,
          gate: gateDeviceIds,
          type: response?.data?.user?.type,
          paid_amount: response?.data?.user?.paid_amount,
          subscription: response?.data?.user?.subscription_id,
          startDate: dayjs(response?.data?.user?.start_date, "YYYY/MM/DD"),
          endDate: dayjs(response?.data?.user?.end_date, "YYYY/MM/DD"),
        });
      } else {
        console.error(response?.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (params?.id) {
      getUser();
    }
  }, []);

  const onPlanChange = async (val: any) => {
    try {
      setSelectedPlan(val);
      setSelectedSub(null);
      setSelectedTok(null);
      setPriceAmount(0);
      setDuration(null);
      setDurationType(null);
      const currentDate = moment();
      setStart_date(currentDate);
      setEnd_date(currentDate);

      form.setFieldsValue({
        subscription: undefined,
        token: undefined,
        paid_amount: 0,
        discount: undefined,
        discount_type: "amount",
        startDate: currentDate,
        endDate: currentDate,
      });
    } catch (err) {
      console.log("Error in onPlanChange:", err);
    }
  };

  const FindDateRange = async (
    durationType: moment.unitOfTime.DurationConstructor,
    duration: number,
    startDate: any
  ) => {
    try {
      let endDate = moment(startDate).add(duration, durationType); // Correct order
      return { start: startDate, end: endDate };
    } catch (err) {
      console.error("Error calculating date range:", err);
      return { start: null, end: null };
    }
  };

  const checkAdmissionId = async (suffix: any) => {
    try {
      if (suffix) {
        const payload = { suffix, office_id: User?.office?.id };
        const response: any = await POST(API.CHECK_ADMSN_ID, payload);
        return response.status;
      }
      return false;
    } catch (error) {
      console.error("Error checking admission ID:", error);
      return false;
    }
  };

  const onValuesChange = (val: any, data: any) => {
    if (val?.discount || val.discount === "") {
      if (data.discount_type === "amount") {
        let amount;
        if (data.plan_type === "token") {
          amount = price_amount * data.tokenCount - Number(val?.discount);
        } else {
          amount = price_amount - Number(val?.discount);
        }
        form.setFieldsValue({ paid_amount: amount });
        form.setFieldsValue({ paided_amount: amount });
      } else {
        let perAmount;
        if (data.plan_type === "token") {
          perAmount =
            price_amount * data.tokenCount -
            (price_amount * data.tokenCount * Number(val?.discount)) / 100;
        } else {
          perAmount =
            price_amount - (price_amount * Number(val?.discount)) / 100;
        }
        form.setFieldsValue({ paid_amount: perAmount });
        form.setFieldsValue({ paided_amount: perAmount });
      }
    }
    if (val.tokenCount) {
      const amountCount = price_amount * val.tokenCount;
      form.setFieldsValue({ paid_amount: amountCount });
      form.setFieldsValue({ paided_amount: amountCount });
    }
  };

  useEffect(() => {
    const tokenCount = form.getFieldValue("tokenCount") || 1;
    const paidAmount =
      tokenCount > 1 ? price_amount * tokenCount : price_amount;
    form.setFieldsValue({
      paid_amount: paidAmount,
      paided_amount: paidAmount,
    });
  }, [price_amount, form]);

  return (
    <div>
      <PageHeaders
        title={params?.id ? "Update User" : "Create User"}
        breadcrumb={params?.id ? "Update User" : "Create User"}
      />
      <div className="screenBox">
        <Card>
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            hideRequiredMark
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            initialValues={{
              prefix1: "+91",
              prefix2: "+91",
              type: "user",
            }}
          >
            <Row>
              <h5 className="user-heading">Basic Details</h5>
              <Col md={4}>
                {" "}
                <Form.Item
                  name="prefix"
                  label="Prefix"
                  initialValue={User?.office?.prefix}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="suffix"
                  label="Admission Number"
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (params?.id) return Promise.resolve();
                        if (!value) return Promise.resolve();

                        const exists = await checkAdmissionId(value);
                        if (exists) {
                          return Promise.reject(
                            "This admission number already exists"
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={params?.id ? true : false} type="number" />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="first_name"
                  label="First Name"
                  rules={[
                    { required: true, message: "First Name is required." },
                  ]}
                >
                  <Input placeholder="Eg: John" />
                </Form.Item>
              </Col>
              <Col md={4}>
                {" "}
                <Form.Item name="last_name" label="Last Name">
                  <Input placeholder="Eg: John" />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="mobile_number"
                  label="Primary Number"
                  rules={[{ required: true, message: "Enter Primary Number" }]}
                >
                  <Input
                    addonBefore={
                      <Form.Item name="prefix1" style={{ marginBottom: -1 }}>
                        <Select
                          defaultValue="+91"
                          size="small"
                          showSearch
                          style={{ width: 75 }}
                        >
                          {CountryCode.map((item, idx) => (
                            <Select.Option value={item.dial_code} key={idx}>
                              {item.dial_code}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    }
                    placeholder="Primary Mobile Number"
                    type="tel"
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item name="mobile_number2" label="Secondary Mobile">
                  <Input
                    addonBefore={
                      <Form.Item name="prefix2" style={{ marginBottom: -1 }}>
                        <Select
                          defaultValue="+91"
                          size="small"
                          showSearch
                          style={{ width: 75 }}
                        >
                          {CountryCode.map((item, idx) => (
                            <Select.Option value={item.dial_code} key={idx}>
                              {item.dial_code}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    }
                    placeholder="Secondary Mobile Number"
                    type="tel"
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
              <Col md={4}>
                {" "}
                <Form.Item name="email" label="Email">
                  <Input type="email" placeholder="Eg: john@gmail.com" />
                </Form.Item>
              </Col>
              <Col md={4}>
                {" "}
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[{ required: true, message: "Choose a Gender" }]}
                >
                  <Select placeholder="Choose a Gender">
                    <Select.Option value="male">Male</Select.Option>
                    <Select.Option value="female">Female</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="birth_date"
                  label="Date of Birth"
                  rules={[
                    { required: true, message: "DOB is required." },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }
                        const currentDate = dayjs();
                        if (value.isAfter(currentDate, "day")) {
                          return Promise.reject(
                            "Date of birth cannot be in the future"
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    allowClear
                    disabledDate={(current: any) => {
                      return current && current > moment().endOf("day");
                    }}
                    placeholder="Eg: 10-11-1996"
                  />
                </Form.Item>
              </Col>
              <Col md={4}>
                {" "}
                <Form.Item name="blood" label="Blood Group">
                  <Select
                    placeholder="Choose Blood Group"
                    showSearch
                    allowClear
                  >
                    {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(
                      (blood, idx) => (
                        <Select.Option value={blood} key={idx}>
                          {blood}
                        </Select.Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item name="weight" label="Weight (KG)">
                  <Input placeholder="Eg: 60" type="number" />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item name="height" label="Height (Cm)">
                  <Input placeholder="Eg: 170" type="number" />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="place"
                  label="Address"
                  rules={[{ required: true, message: "Choose a Address" }]}
                >
                  <TextArea rows={8} />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item name="userImage" label="User Image">
                  <ImagePicker
                    fileURL={userId?.photo || image1?.url}
                    onChange={(val) => setImage1(val)}
                    aspectRatio={1 / 1}
                    height={"25vh"}
                  />
                </Form.Item>
              </Col>
              <Col md={4}>
                {" "}
                <Form.Item name="" label="ID Proof">
                  <ImagePicker
                    fileURL={userId?.id_proof || image2?.url}
                    onChange={(val) => setImage2(val)}
                    aspectRatio={1 / 1}
                    height={"25vh"}
                  />
                </Form.Item>
              </Col>
            </Row>

            {!params?.id && (
              <Row>
                <h5 className="user-heading">Subscription Details</h5>
                <Col md={4}>
                  <Form.Item
                    name="plan_type"
                    label="Plan Type"
                    initialValue="subscription"
                  >
                    <Select
                      placeholder="Choose Plan Type"
                      optionFilterProp="label"
                      onChange={(value) => onPlanChange(value)}
                      options={[
                        { value: "subscription", label: "Subscription" },
                        { value: "token", label: "Token" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={4}>
                  {selectedPlan === "subscription" ? (
                    <Form.Item
                      name="subscription"
                      label="Subscription Plan"
                      rules={[
                        {
                          required: !!(selectedSub || selectedTok),
                          message: "Please select a payment method",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Choose a Subscription Plan"
                        onChange={handleSubscriptionChange}
                        allowClear
                      >
                        {subscription?.map((item: any) => (
                          <Select.Option
                            key={item?.id}
                            id={item?.id}
                            name={item?.name}
                            price={item?.price}
                            duration_type={item?.duration_type}
                            duration={item?.duration}
                          >
                            {item.name} - {item.duration} {item.duration_type} -
                            ₹{item.price}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item name="token" label="Token Plan">
                      <Select
                        placeholder="Choose a Token Plan"
                        onChange={handleSubscriptionChange}
                        allowClear
                      >
                        {tokens?.map((item: any) => (
                          <Select.Option
                            key={item?.id}
                            id={item?.id}
                            name={item?.name}
                            price={item?.price}
                            duration_type={item?.duration_type}
                            duration={item?.duration}
                          >
                            {item.name} - {item.duration} {item.duration_type} -
                            ₹{item.price}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
                {selectedPlan === "token" && (
                  <Col md={4}>
                    <Form.Item initialValue={1} label="Count" name="tokenCount">
                      <Input min={1} type="number" />
                    </Form.Item>
                  </Col>
                )}
                {selectedPlan === "token" && (
                  <Col md={4}>
                    <Form.Item label="Price Per Token" name="price_per_token">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                )}

                <Col md={4}>
                  <Form.Item
                    name="discount_type"
                    label="Discount Type"
                    initialValue="amount"
                  >
                    <Select
                      placeholder="Choose Discount Type"
                      optionFilterProp="label"
                      options={[
                        { value: "amount", label: "Amount" },
                        { value: "percentage", label: "Percentage" },
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col md={4}>
                  <Form.Item label="Discount" name="discount">
                    <Input type="number" min={0} />
                  </Form.Item>
                </Col>

                <Col md={4}>
                  <Form.Item label="Amount" name="paid_amount">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col md={4}>
                  <Form.Item
                    label="Paid Amount"
                    name="paided_amount"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const maxValue = getFieldValue("paid_amount");
                          if (value === undefined || value === null)
                            return Promise.resolve();
                          if (value > maxValue) {
                            return Promise.reject(
                              `Paid amount cannot exceed ${maxValue}`
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      onChange={(e) => {
                        const maxValue = form.getFieldValue("paid_amount");
                        let inputValue = Number(e.target.value);
                        if (inputValue > maxValue) {
                          form.setFieldsValue({ paided_amount: maxValue });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col md={4}>
                  <Form.Item name="startDate" label="Start Date">
                    <DatePicker
                      style={{ width: "100%" }}
                      value={
                        start_date && dayjs(start_date).isValid()
                          ? dayjs(start_date)
                          : null
                      }
                      onChange={(value:any) => {
                        if (value) {
                          setStart_date(value);
                          form.setFieldsValue({ startDate: value });

                          // Automatically calculate end date based on duration and duration type
                          if (duration && durationType) {
                            const calculatedEndDate = dayjs(value).add(duration, durationType);
                            setEnd_date(calculatedEndDate);
                            form.setFieldsValue({ endDate: calculatedEndDate });
                          }
                        } else {
                          setStart_date(null);
                          form.setFieldsValue({ startDate: null });
                        }
                      }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col md={4}>
                  <Form.Item name="endDate" label="End Date">
                    <DatePicker
                      style={{ width: "100%" }}
                      format="YYYY-MM-DD"
                      value={
                        end_date && dayjs(end_date).isValid()
                          ? dayjs(end_date)
                          : null
                      }
                      onChange={(value) => {
                        if (value && dayjs(value).isValid()) {
                          setEnd_date(value);
                          form.setFieldsValue({ endDate: value });

                          // Automatically calculate start date based on duration and duration type
                          if (duration && durationType) {
                            const calculatedStartDate = dayjs(value).subtract(duration, durationType);
                            setStart_date(calculatedStartDate);
                            form.setFieldsValue({ startDate: calculatedStartDate });
                          }
                        } else {
                          setEnd_date(null);
                          form.setFieldsValue({ endDate: null });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={4}>
                  <Form.Item
                    name="payment_method"
                    label="Payment Method"
                    rules={[
                      {
                        required: !!(selectedSub || selectedTok),
                        message: "Please select a payment method",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Choose Payment Method"
                      showSearch
                      allowClear
                    >
                      {["BANK", "UPI", "CARD", "CASH"].map((method, idx) => (
                        <Select.Option value={method} key={idx}>
                          {method}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              <h5 className="user-heading">GateWays</h5>
              <Col md={4}>
                <Form.Item name="gate" label="GateWay">
                  <Select
                    placeholder="Choose GateWay"
                    mode="multiple"
                    showSearch
                    allowClear
                  >
                    {User?.office?.devices?.map((item: any, idx: number) => (
                      <Select.Option value={item?.device_id} key={idx}>
                        {item?.device_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <h5 className="user-heading">Account Type</h5>
              <Col md={4}>
                <Form.Item name="type" label="Account Type" initialValue="user">
                  <Select
                    placeholder="Choose an Account Type"
                    onChange={handleAccountTypeChange}
                    allowClear
                  >
                    <Select.Option value="user">User</Select.Option>
                    <Select.Option value="trainer">Trainer</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              {accountType === "trainer" && (
                <Col md={4}>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[{ required: true, message: "Enter a Password" }]}
                  >
                    <Input.Password />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Row>
              <Col></Col>
              <Col sm={4}>
                <Button size="large" danger block onClick={() => navigate(-1)}>
                  Close
                </Button>
              </Col>
              <Col sm={4}>
                <Button
                  size="large"
                  type="primary"
                  block
                  htmlType="submit"
                  loading={isLoading}
                >
                  {params?.id ? "Update" : "Submit"}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default CreateBooking;
